/** Robot Cargo: `robot` (до подъезда) и `robot_d2d` (до двери). */
export function isRobotYandexDeliveryType(yandexDeliveryType: string | null | undefined): boolean {
  return yandexDeliveryType === 'robot' || yandexDeliveryType === 'robot_d2d'
}

/** Робот Яндекс Еды (marketplace) — из курьерской нотификации. */
export function isYandexEatsRobot(isYandexRobot: boolean | null | undefined): boolean {
  return isYandexRobot === true
}

/** Курьер Яндекс Еды (marketplace) — из нотификации, не робот. */
export function isYandexEatsCourier(isYandexRobot: boolean | null | undefined): boolean {
  return isYandexRobot === false
}
